import { render, staticRenderFns } from "./TabLog.vue?vue&type=template&id=388577a3&"
import script from "./TabLog.vue?vue&type=script&lang=js&"
export * from "./TabLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports